"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const CheckIcon_1 = __importDefault(require("../icons/CheckIcon"));
const AlertIcon_1 = __importDefault(require("../icons/AlertIcon"));
const Status = ({ children, verify, margin = 'default', hidden = false, size = 12 }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.container, marginStyles[margin]]) },
        !hidden && (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
                styles.circle,
                verify && styles.successful,
                !verify && styles.failed,
                verify === null && styles.pending,
                {
                    height: size,
                    width: size,
                    borderRadius: size / 2,
                },
            ]) },
            verify && react_1.default.createElement(CheckIcon_1.default, null),
            verify === false && react_1.default.createElement(AlertIcon_1.default, { style: styles.icon }))),
        children));
};
exports.default = Status;
const marginStyles = react_native_1.StyleSheet.create({
    default: {
        marginBottom: styles_1.getSpacing(),
    },
    dense: {
        marginBottom: styles_1.getSpacing(0.5),
    },
    none: {
        marginBottom: 0,
    },
});
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    circle: {
        marginRight: styles_1.getSpacing(0.5),
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        height: 10,
        width: 10,
        tintColor: styles_1.Colors.white,
    },
    pending: { backgroundColor: styles_1.Colors.primary },
    successful: { backgroundColor: styles_1.Colors.green },
    failed: { backgroundColor: styles_1.Colors.red },
});
